import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import React, { useEffect ,useContext  ,useState} from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import routes from "./constants/routes.json";
import constantValues from "./constants/constantValues.json";
import LandingPage from "./containers/LandingPage";
import NominationsPage from "./containers/NominationsPage";
import NotificationsPage from "./containers/NotificationsPage";
import NewAssociationPage from "./containers/NewAssociationPage";
import CandidateList from "./containers/CandidateList";
import Result from "./containers/Result";
import Voting from "./containers/Voting";
import PrivateRoute from "./PrivateRoute";
import LoginPage from "./containers/LoginPage";
import IdleTimer, { useIdleTimer } from "react-idle-timer";
import { store } from "./contexts/store";
import {SPECIAL_TOKEN ,POSITION_LIST, VOTE_LIST} from "../src/contexts/types"
import API from "../src/Api/api";
import { VotingContextProvider  } from "./components/Voting/VotingContext";

  
const App = () => {
   const globalState = useContext(store);
  
  const { dispatch } = globalState;
 
 
const userIsLoggedIn = !!globalState.state?.usertoken;
localStorage.setItem("userid",globalState.state.user._id)

     const [voted, setVoted] = useState(true);
    const [hasLoggedOut, setHasLoggedOut] = useState(false);
  const env = process.env.REACT_APP_ENV;
 


 
  const handleOnIdle =   async ()  => {
   
 
        
    if (env !== "development" && window.location.href !== routes.LOGIN) {
      

      window.location.href = routes.LOGIN;
    }
  };
const getSpecialTokenApi = async (mode) => {
 
    
   
    const mobile = globalState?.state?.user?.mobile || localStorage.getItem("mobile");
     const token = globalState?.state?.usertoken || localStorage.getItem("usertoken");
     const userid = globalState.state.user._id ||localStorage.getItem("userId")
 
  if (!mobile || !token) {
    console.warn("Missing mobile/token — skipping special token fetch.");
    return;
  }

  try {
    const response = await API.getSpecialToken(mobile, 1, token);
    const specialToken = response.data.token;
    dispatch({ type: SPECIAL_TOKEN, payload: specialToken });

   localStorage.setItem("specialToken",specialToken)
  
    await saveVotesApi(mode, specialToken);
  } catch (e) {
    console.error("Error fetching special token:", e);
    throw e;
  }
    
  };
  
  const saveVotesApi=async (mode,specialTocken)=>{
   
  //  const voteList =  localStorage.getItem("voteList")!= undefined ?  JSON.parse(localStorage.getItem("voteList")) : [];
    let storedVoteList = localStorage.getItem("voteList");
let voteList = [];

try {
  voteList = storedVoteList ? JSON.parse(storedVoteList) : [];
} catch (e) {
  console.error("Invalid voteList in localStorage:", e);
  voteList = [];
}
     const userid = localStorage.getItem("userId")
     const mobile = globalState?.state?.user?.mobile || localStorage.getItem("mobile");
     const special_Token = localStorage.getItem("specialToken")
      
    //let list=[];
    dispatch({ type: VOTE_LIST, payload: globalState.state.voteList  })
     const list = voteList.map((vote) => ({
    positionId: vote.positionId,
    candidateId: vote.candidateId,
  }));

  // console.log("Final draft list", list);
return API.saveVotes(
    userid,
    mode,
    list,
    special_Token,
    mobile
  )
    .then(() => {
setVoted(mode);
     // setVoted(mode === "Submitted");
      //console.log("mode>>>",mode)
       // ✅ Clear localStorage items after success
      localStorage.removeItem("voteList");
      localStorage.removeItem("specialToken");
      localStorage.removeItem("userToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("mobile");
    })
    .catch((e) => {
      console.log("Error saving votes", e);
      throw e;
    });
    
  

  };
  const { start, reset  } = useIdleTimer({  
    timeout: 1000 * 60 * constantValues.TIMEOUT,
    onIdle: handleOnIdle,
    debounce: 250,
    crossTab: true,
  startOnMount: false, // prevent it from starting automatically
  });
  const preventRightClick = () => {
    // disable right click
    document.addEventListener("contextmenu", (event) => event.preventDefault());

    document.onkeydown = function (e) {
      console.log(e)
      // disable F12 key
      if (e.keyCode == 123) {
        return false;
      }

      // disable I key
      if (e.ctrlKey && e.shiftKey && e.keyCode == 73) {
        return false;
      }

      // disable J key
      if (e.ctrlKey && e.shiftKey && e.keyCode == 74) {
        return false;
      }

      // disable U key
      if (e.ctrlKey && e.keyCode == 85) {
        return false;
      }
    };
  };

  useEffect(() => {
    if (env !== "development") preventRightClick();
  }, []);
  useEffect(() => {
  

  if (userIsLoggedIn) {
    setHasLoggedOut(false); // allow future idle detection
    start(); //  start idle detection
  } else {
    //  Check if any vote-related data still exists in localStorage
    const voteList = localStorage.getItem("voteList");
    const userId = localStorage.getItem("userId");
    const mobile = localStorage.getItem("mobile");
    const specialToken = localStorage.getItem("specialToken");

    const hasPendingData = voteList || userId || mobile || specialToken;

    if (hasPendingData) {
      
      getSpecialTokenApi("Draft"); //  Save remaining vote list
    } else {
     // console.log("No pending data — nothing to sync");
    }

    reset(); // stop idle timer
  }
}, [userIsLoggedIn]);
// useEffect(() => {
//   console.log("Idle handler called at", new Date().toLocaleTimeString());
  
//   if (userIsLoggedIn) {
//     start();
//   } else {
//      getSpecialTokenApi("Draft"); 
//     reset();
//   }
// }, [userIsLoggedIn]);
  return (
    <div>
     
      <div
        className={"App " + (env !== "development" ? "no_selection" : "")}
        onContextMenu={(e) =>
          env !== "development" ? e.preventDefault() : void 0
        }
      >
        <Router>
          <Switch>
            <Route path={routes.LOGIN} component={LoginPage} exact />
            <PrivateRoute exact path={routes.LANDING} component={LandingPage} />
            <PrivateRoute
              exact
              path={routes.NOMINATIONS}
              component={NominationsPage}
            />
            <PrivateRoute
              exact
              path={routes.NOTIFICATIONS}
              component={NotificationsPage}
            />
            <PrivateRoute
              exact
              path={routes.NEWASSOCIATION}
              component={NewAssociationPage}
            />
            <PrivateRoute
              exact
              path={routes.CANDIDATELIST}
              component={CandidateList}
            />
            <PrivateRoute exact path={routes.RESULT} component={Result} />
            <PrivateRoute exact path={routes.Voting} component={Voting} />
          </Switch>
        </Router>
      </div>
    </div>
  );
};

export default App;
